import { pathOr, reduce } from 'lodash/fp';
import { BaseSyntheticEvent } from 'react';

import { AppRoute, routesList } from '../containers/Routes/routesList';

export function getComponentName(Component: React.ComponentType<unknown>) {
  return Component.displayName || Component.name || 'Component';
}

type ReactHookDispatcher = (value: React.SetStateAction<any>) => void;
export const dispatcherToEventListener = (
  dispatcher: ReactHookDispatcher,
  eventPath = ['target', 'value']
) => (e: BaseSyntheticEvent) => dispatcher(pathOr('', eventPath, e));

export const createValidRoute = (
  route: AppRoute,
  params?: { [k: string]: string | number },
  extra = ''
) => {
  const theRoute: string = routesList[route];
  if (!params) {
    return theRoute;
  }

  const keys = Object.keys(params);
  return reduce(
    (p, c) => p.replace(`:${c}`, `${params[c]}`),
    theRoute,
    keys
  ).concat(extra);
};
